import { Image, Stack } from "@chakra-ui/react";
import React from "react";
import { colors } from "../../styles";
import { getAdSrc } from "./adOrder";

interface IADDividerProps {
    slotIndex: number;
}

function ADDivider({ slotIndex }: IADDividerProps) {
    return (
        <Stack
            width={{
                base: "100%",
                sm: "100%",
                md: "100%",
                lg: "80%",
                xl: "80%",
            }}
            overflow={"hidden"}
            spacing={0}
            boxShadow={"0px 1px 2px 0px rgba(0, 0, 0, 0.1)"}
        >
            <Image
                src={getAdSrc(slotIndex)}
                alt={"광고"}
                width={"100%"}
                height={"auto"}
                objectFit={"cover"}
                loading={"lazy"}
                sx={{ aspectRatio: "2172 / 724" }}
            />
        </Stack>
    );
}

export default React.memo(ADDivider);
